import type { AxiosRequestConfig } from 'axios'

import type { SessionTokens, SystemVersion, UserInfo } from '@/types/session'
import request from '@/utils/request'

export function loginByUsername(username: string, password: string) {
  const data = new FormData()

  data.set('username', username)
  data.set('password', password)

  // Keep the legacy nested config sent by the shared request API.
  const config: AxiosRequestConfig<FormData> & { config: { headers: Record<string, string> } } = {
    url: '/authenticate',
    method: 'post',
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    data
  }
  return request<SessionTokens>(config)
}

export function logout(_token?: string) {
  void _token // Accepted for compatibility; authorization comes from the request interceptor.
  return request<unknown>({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo(_token?: string) {
  void _token // Accepted for compatibility; authorization comes from the request interceptor.
  return request<UserInfo>({
    url: '/api/users/me',
    method: 'get'
  })
}

export function getSystemVersion() {
  return request<SystemVersion>({
    url: '/actuator/info',
    method: 'get'
  })
}
